import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React from 'react';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../hooks/useContexts';
import {
  ICardAndTableView,
  IOrderHistoryResponse,
} from '../../models/purchase-history';
import { ITableView } from '../../models/purchase-history/table';
import { PHCardView } from './card-view/PHCardView';
import { ODTable } from './open-deliveries';
import { PHTable } from './table-view/PHTable';

export const CardAndTableView = ({
  orderHistoryModalHooks,
  enableSettingsDrawer,
  setEnableSettingsDrawer,
}: ICardAndTableView) => {
  const { isMobile } = useCommonContext();
  const {
    customerRole,
    customerType,
    orderHistoryData,
    orderHistoryLoaded,
    localDeliveryData,
    pHRequest,
    setAlertState,
    setPHRequest,
    viewType,
  } = usePurchaseHistoryContext();

  const TableViewProps: ITableView = {
    customerRole,
    customerType,
    orderHistoryData: orderHistoryData as IOrderHistoryResponse,
    orderHistoryLoaded,
    orderHistoryModalHooks,
    pHRequest,
    setAlertState,
    setPHRequest,
    enableSettingsDrawer,
    setEnableSettingsDrawer,
  };

  const LocalDeliveriesViewProps = {
    customerType,
    orders: localDeliveryData?.orders,
  };

  if (viewType === 'Card' || isMobile || customerType === 'b2c') {
    return (
      <>
        <ErrorBoundary name="order-card-view">
          <PHCardView customerRole={customerRole} customerType={customerType} />
        </ErrorBoundary>
      </>
    );
  }

  if (viewType === 'LocalDeliveries') {
    return (
      <>
        <ErrorBoundary name="local-deliveries">
          <ODTable {...LocalDeliveriesViewProps} />
        </ErrorBoundary>
      </>
    );
  }

  return (
    <ErrorBoundary name="table-view">
      <PHTable {...TableViewProps} />
    </ErrorBoundary>
  );
};
